export default __webpack_public_path__ + "static/media/upJoystickArrow.e787cd19.svg";